import { Injectable, inject } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AdminProfileStore } from '../store/admin-profile/admin-profile.store';

/**
 * Blocks pages that exist solely to create, generate or change something.
 * Read-only admins are sent back to the dashboard.
 */
@Injectable({
  providedIn: 'root',
})
export class CanWriteGuard implements CanActivate {
  private router = inject(Router);
  private adminProfileStore = inject(AdminProfileStore);

  canActivate(): boolean | UrlTree {
    if (this.adminProfileStore.canWrite()) {
      return true;
    }
    return this.router.parseUrl('/dashboard');
  }
}
